import loadable from '@loadable/component';

export const NewbuildingFlatTourBookingModalContainerLoadable = loadable(
  () => import('./NewbuildingFlatTourBookingModal'),
);
